import API, { commonApiInvoker } from '@api/api'
import axios from 'axios';
import { message } from 'antd';
import Utils from '@utils/utils'
import eventBus from '@utils/eventBus';

// 单个算法生成
export const tasksInpaintBuild = (params) => {
    return commonApiInvoker(API.tasksInpaint({...params}), false, true).then(res => {
        return res
    }).catch(err => {
        if (!err) return
        console.log(err)
        message.error(err.message)
    })
}

// 批量算法生成
export const tasksInpaintBuildBatch = (params) => {
    return commonApiInvoker(API.tasksInpaintBatch({...params}), false, true).then(res => {
        return res
    }).catch(err => {
        if (!err) return
        console.log(err)
        message.error(err.message)
    })
}

// 查单张结果
export const gettasksInpaintResult = (id, stopCondition) => {
    return new Promise((resolve, reject) => {
        const loopFunc = () => {
            commonApiInvoker(API.gettasksInpaintResultLoop(id), false, true).then(res => {
                if ((res.status == 'succeeded')) {
                    resolve(res.output[1])
                } else if (res.status == 'failed') {
                    message.error(`处理失败: ${res.errmsg} (错误码: ${res.errcode})`);
                    reject()
                } else {
                    if (stopCondition && stopCondition()) return reject()
                    setTimeout(() => {
                        loopFunc()
                    }, 1000)
                }
            })

        }
        loopFunc()
    })
}


// 查批量结果
export const gettasksInpaintResultBatch = (id, stopCondition, getUpdateResult) => {
    return new Promise((resolve, reject) => {
        const loopFunc = () => {
            commonApiInvoker(API.gettasksInpaintResultLoopBatch(id), false, true).then(res => {
                getUpdateResult(res)
                const task = res?.find(item => (
                    (item.status != 'succeeded' && item.status != 'failed')
                ))
                if(task) {
                    if (stopCondition && stopCondition()) return resolve()
                    setTimeout(() => {
                        loopFunc()
                    }, 5000)
                } else {
                    resolve(res)
                }
            })

        }
        loopFunc()
    })
}

// 高清改尺寸
export const doSrResize = (url, target_size, stopCondition) => {
    return commonApiInvoker(API.doSrResize({
        img_path: url,
        target_size: target_size.join(',')
    }), false, true).then(res => {
        return loopDoSrResize(res, stopCondition)
    }).catch(err => {
        if (!err) return
        console.log(err)
    })
}
export const loopDoSrResize = (id, stopCondition) => {
    return new Promise((resolve, reject) => {
        const loopFunc = () => {
            commonApiInvoker(API.loopDoSrResize(id), false, true).then(res => {
                if((res.status == 'succeeded')) {
                    resolve({
                        id,
                        output: res.output,
                    })
                } else if(res.status == 'failed') {
                    message.error(res.errcode)
                    reject()
                } else {
                    if (stopCondition && stopCondition()) return resolve()
                    setTimeout(() => {
                        loopFunc()
                    }, 600)
                }
            })

        }
        loopFunc()
    })
}


export default {
    tasksInpaintBuild,
    tasksInpaintBuildBatch,
    gettasksInpaintResult,
    gettasksInpaintResultBatch,
    doSrResize
}


